import storyCard from './story-card/storyCard';

const toLoad = [
  storyCard
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
